import { gql } from 'apollo-boost'

const DELETE_SCRAPING_TAG_GROUP = gql`
  mutation deleteScrapingTagGroup($id: ID!) {
    deleteScrapingTagGroup(id: $id)
  }
`

export default DELETE_SCRAPING_TAG_GROUP
